// Angular Imports
import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
	name: 'titleCaseNumber',
	standalone: true,
})
export class TitleCaseNumberPipe implements PipeTransform {
	transform(value: any, ...args: Array<unknown>): string {
		if (typeof value === 'string') {
			return this._titlecase(value)
		} else if (typeof value === 'number') {
			return value.toString() // We only return the number as a string
		} else {
			return '' // Handle other data types as desired
		}
	}

	// Private method called _titlecase that takes a string of text as an argument and returns a new string with the first letter of each word capitalized
	private _titlecase(string: string): string {
		return string
			.toLowerCase()
			.replace(/(^|\s)[a-z\u00E0-\u00FC]/g, (char) => char.toLocaleUpperCase())
	}
}
